"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tsenum_1 = require("@gradecam/tsenum");
exports.SourceMapMode = tsenum_1.MakeEnum({
    Inline: 'inline',
    Separate: 'separate'
});
